type Config = {
  appUrl: string;
  appSubUrl: string;
  csrfToken: string;
  featureFlags: Record<string, boolean>;
  renderVersion: string;
};

const DEFAULT_CONFIG: Config = {
  appUrl: '',
  appSubUrl: '',
  csrfToken: '',
  featureFlags: {},
  renderVersion: 'unknown-version',
};

let CONFIG: Config | null = null;
export function getConfig(): Config {
  if (CONFIG === null) {
    const windowConfig = window?.config ?? {};

    CONFIG = {
      ...DEFAULT_CONFIG,
      ...windowConfig,
    };
  }

  return CONFIG;
}
